/* eslint-disable no-dupe-keys */
export default {
  idle_fee_settlement_rule: {
    name: '占位结算规则',
    // 属性（一般与对象内容匹配）
    prop: {
      settlement_monthly_days: '结算时间',
      tax_rate: '税率',
      transaction_fee_rate: '手续费率',
      idle_fee_bills_amount: '结算占位费账单总额',
      idle_fee_bills_count: '结算占位费账单数量',
      created_at: '创建时间',
      updated_at: '更新时间'
    },
    // Enum的属性
    // 占位提示
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      ev_charging_station_settlements: '站结算记录',
      idle_fee_bill_settlements: '占位费账单结算记录'
    },
    // 标签标题
    // 标题
    titles: {
      base_info: '基本信息',
      ev_charging_station: '结算站',
      idle_fee_summary: '上月的占位费结算汇总'
    }
  }
}
